import { useState, useEffect } from "react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      aria-label="Back to top"
      className="lg:hidden fixed z-50 right-4 cursor-pointer transition-all duration-300 active:scale-90"
      style={{ bottom: "calc(env(safe-area-inset-bottom) + 80px)" }}
    >
      <div
        className="w-11 h-11 flex items-center justify-center rounded-full"
        style={{
          background: "linear-gradient(135deg, #B8860B, #FFD700)",
          boxShadow: "0 4px 16px rgba(184,134,11,0.35)",
        }}
      >
        <i className="ri-arrow-up-line text-xl font-bold" style={{ color: "#1a0f00" }} />
      </div>
    </button>
  );
}
